import { SaleModel } from '@shared/app/scripts/classes/sale-model';
import { merge } from 'lodash';

/**
 * Links one document to another
 */
export class LinkModel {
  id: string;
  resource: string;
  type: string;
  comment: string;
}

/**
 * TODO document the class
 */
export class ConsignmentModel extends SaleModel {
  status: string;
  link: LinkModel;

  constructor(originalValue?: Partial<SaleModel>) {
    super();
    merge(this, originalValue);
  }
}

// Hack! It makes sure that in the test scripts & test are using the same
// reference to the class
export const ConsignmentModelProvider = {
  provide: 'ConsignmentModel',
  useValue: ConsignmentModel,
};
